import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const SpinnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${({ $fullScreen }) => $fullScreen ? '100vh' : '200px'};
  gap: ${({ theme }) => theme.spacing.md};
`;

const SpinnerText = styled.div`
  color: ${({ theme }) => theme.colors.textMuted};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
`;

const LoadingSpinner = ({
  size = 'default',
  text,
  fullScreen = false,
  className,
}) => {
  const spinnerSizes = {
    small: 24,
    default: 40,
    large: 64,
  };

  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: spinnerSizes[size] || spinnerSizes.default,
        color: 'var(--odin-accent)',
      }}
      spin
    />
  );

  return (
    <SpinnerContainer $fullScreen={fullScreen} className={className}>
      <Spin indicator={antIcon} />
      {text && <SpinnerText>{text}</SpinnerText>}
    </SpinnerContainer>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.oneOf(['small', 'default', 'large']),
  text: PropTypes.string,
  fullScreen: PropTypes.bool,
  className: PropTypes.string,
};

export default LoadingSpinner;
